<template>
  <div>
    <v-content>
      <section v-cloak>
        <v-parallax
          :src="require('@/assets/beach-tsv2.jpg')"
          height="770"
          class="banner"
        >
          <Navbar></Navbar>
          <v-layout column align-center justify-center class="white--text">
            <img
              class="mb-3"
              src="../assets/logo.svg"
              alt="STIP"
              height="270"
            />
            <!--<div class=" display-1 pt-3 text-center">North Queensland</div>-->
            <h1 class="white--text pt-3 display-3 font-weight-bold text-center">
              Strata Inspection Program
            </h1>
            <div class="title pt-3 pb-1 text-center font-weight-bold">
              Improving the Resilience of Strata Properties

            </div>
            <div class="title pt-1 pb-3 text-center font-weight-bold">

              <!--Sign up to be put on the waiting list for an inspection of your property-->
            </div>

            <!--<v-btn
              class="blue lighten-2 mt-3 mb-3"
              dark
              large
              @click="gotoRegister"
            >
              Request Inspection
            </v-btn>-->
          </v-layout>
        </v-parallax>
      </section>
      <section class="mt-5 pt-5">

        <v-container grid-list-xl >
          <v-layout row wrap align-center>
            <v-flex xs12 >
              <v-card
                      class="elevation-0 transparent text-center">
                <h2 class="headline ">Strata Inspection Program (SIP)</h2>
                <span class="subheading"
                  > <!--Register for Your Property To Go on the Waiting List-->
                  </span
                >
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
      <section class="ma-5 pa-5" >
        <v-container grid-list-xl>


          <v-layout row wrap justify-center>
            <v-flex xs12>
              <v-container >
                <v-layout row wrap >
                  <v-flex sm12 md6>
                    <v-card class="elevation-0 transparent "  height="100%">
                      <v-card-text class="text-center">
                        <v-icon x-large class="blue--text text--lighten-2"
                          >mdi-view-dashboard</v-icon
                        >
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="headline">About Us</div>
                      </v-card-title>
                      <v-card-text class="" >
                        <span class="text-justify " ><!--Our program is funded and administered by the
                        Queensland Government.--> The program is run by
                          the </span><a
                          href="https://www.jcu.edu.au/cyclone-testing-station"
                          >Cyclone Testing Station</a
                        >at<a  href="https://www.jcu.edu.au"
                          >James Cook University.</a
                        >
                        <span class="text-justify">Click below to see if your property is within the
                          region covered by the program.</span>
                      </v-card-text>
                      <v-flex xs12 class="text-center">
                        <!--<v-btn
                          class=" mt-3 mb-3 blue&#45;&#45;text "
                          color="blue "
                          dark
                          large
                          outlined
                          @click="gotoAbout"
                        >
                          About Us
                        </v-btn>-->
                      </v-flex>
                    </v-card>
                  </v-flex>
                  <!--<v-flex sm12 md4>
                    <v-card class="elevation-0 transparent"  height="100%">
                      <v-card-text class="text-center">
                        <v-icon x-large class="blue&#45;&#45;text text&#45;&#45;lighten-2"
                          >mdi-clipboard-list-outline</v-icon
                        >
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="headline">Request an Inspection</div>
                      </v-card-title>
                      <v-card-text class="text-justify">
                        Sign up to request an inspection of your property. A
                        trained building inspector will assess the grounds and
                        buildings at your property. You will receive a report
                        with resilience estimates and recommendations to
                        minimise damage from wind, rain and storm surge.
                      </v-card-text>
                      <v-flex xs12 class="text-center">
                        &lt;!&ndash;<v-btn
                          class=" mt-3 mb-3 blue&#45;&#45;text "
                          color="blue "
                          dark
                          large
                          outlined
                          @click="gotoRegister"
                        >
                          Request Inspection
                        </v-btn>&ndash;&gt;
                      </v-flex>
                    </v-card>
                  </v-flex>-->
                  <v-flex sm12 md6>
                    <v-card class="elevation-0 transparent"  height="100%">
                      <v-card-text class="text-center">
                        <v-icon x-large class="blue--text text--lighten-2"
                        >mdi-tooltip-account</v-icon
                        >
                      </v-card-text>
                      <v-card-title primary-title class="layout justify-center">
                        <div class="headline">Register Interest</div>
                      </v-card-title>
                      <v-card-text class="text-justify">
                       The current funding round has been fully allocated. Contact us at<a href="mailto:stratatitle@jcu.edu.au">stratatitle@jcu.edu.au</a>for any questions.
                      </v-card-text>

                      <v-flex xs12 class="text-center">
                        <!--<v-btn
                                class=" mt-3 mb-3 blue&#45;&#45;text "
                                color="blue "
                                dark
                                large
                                outlined
                                @click="gotoInterest"

                        >
                          Register Interest
                        </v-btn>-->
                      </v-flex>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>

          <!--<v-alert type="info" xs8 class="text-center " >
            Please note that all inspections are carried out under our
            <a class="white&#45;&#45;text ma-0 pa-0"
                    href="https://www.jcu.edu.au/__data/assets/pdf_file/0007/1058740/NQSTIP-COVID-19-Policy-V1.pdf"
            >COVID-19 policy.</a>
          </v-alert>-->

        </v-container>
      </section>
      <section>
        <v-parallax :src="require('@/assets/beach.jpg')" height="600">
          <section>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <v-card class="elevation-0 transparent text-center" dark>
                    <h2 class="headline mt-5 font-weight-bold">
                      Our Partners
                    </h2>
                    <span class="subheading font-weight-bold">
                      We appreciate the continued support of our partners
                    </span>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </section>
          <section>
            <v-container>
              <v-layout column align-center justify-center class="mb-5">
                <a href="https://www.qld.gov.au">
                  <img src="../assets/qld-logo.png" alt="SIP" height="150" />
                </a>
                <v-layout row align-center justify-center>
                  <a href="https://www.jcu.edu.au" class="pb-2">
                    <img
                      class="mt-3"
                      src="../assets/jcua-logo-mono-reversed-2018.svg"
                      alt="SIP"
                      height="84"
                    />
                  </a>
                  <a
                    href="https://www.jcu.edu.au/cyclone-testing-station"
                    class="pt-2"
                  >
                    <img
                      class="mt-3"
                      src="../assets/Cyclone-Testing-Station-Logo-cropped-min.svg"
                      alt="SIP"
                      height="62"
                    />
                  </a>
                </v-layout>
              </v-layout>
            </v-container>
          </section>
        </v-parallax>
      </section>
      <section class="ma-5 pa-5" >
        <v-container grid-list-xl>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-card class="elevation-0 transparent text-center">
                <h2 class="headline mt-5">Our Process</h2>
                <span class="subheading"
                  >Follow these steps to get your report</span
                >
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
      <section class="ma-5 pa-5" >
        <v-container grid-list-xs>
          <v-layout flex-child wrap>
            <v-flex
              v-for="(item, i) in items"
              xs12
              sm12
              md2
              :key="i"
              @click="gotoProcess"
            >
              <v-hover>
                <template v-slot="{ hover }">

                  <v-card
                      :elevation="hover ? 4 : 0"
                      align-center hover tile  class="stepper-wrapper ">
                <v-flex

                  column
                  dark
                  mt-auto
                  align-end
                  justify-center
                  d-flex
                  class="text-center
                                stepper-top"
                >
                  <div class="stepper-icon">
                    <v-avatar color="blue lighten-2">
                      <v-icon dark>{{ item.icon }}</v-icon>
                    </v-avatar>
                  </div>
                </v-flex>
                <v-flex
                  column
                  dark
                  mt-auto
                  align-center
                  justify-center
                  class="text-center
                               stepper-bottom "
                >
                  <div class="pa-2">
                    {{ item.text }}
                  </div>
                </v-flex>
                <sheet-footer>
                  {{ item.step }}
                </sheet-footer>
              </v-card>
                </template>
              </v-hover>
            </v-flex>
          </v-layout>
          <v-flex xs12 class="text-center mt-5">
            <v-btn
                    class=" ma-3 white--text "
                    color="blue "
                    large
                    outlined
                    href="https://www.jcu.edu.au/?a=1926187"

            >
              Summary Sample Report
            </v-btn>
            <v-btn
                    class=" ma-3  white--text "
                    color="blue "
                    large
                    outlined

                    href="https://www.jcu.edu.au/?a=1171395"

            >
              Sample Report
            </v-btn>
            <v-btn
              class=" ma-3  blue--text "
              color="blue "
              dark
              large
              outlined
              @click="gotoProcess"
            >
              More About Our Process
            </v-btn>
          </v-flex>
        </v-container>
      </section>
      <section >
        <v-parallax :src="require('@/assets/damage-home.jpg')" height="750">
          <section>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <v-card class="elevation-0 transparent text-center" dark>
                    <h2 class="headline mt-5 font-weight-bold">
                      Make Your Property More Resilient
                    </h2>
                    <span class="subheading font-weight-bold">
                      Take Action to Improve Resilience
                    </span>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </section>
          <section>
            <v-container class="mb-5">
              <v-layout column wrap>
                <v-flex xs12>
                  <div class="text-center">
                    <p class="font-weight-bold">
                      Even before your property is assessed, you can undertake
                      measures to improve the resilience of your property to
                      damage from the effects of tropical cyclones. For example:
                    </p>
                    <ul
                      class="pr-5 font-weight-bold"
                      style="list-style-type: none;"
                    >
                      <li>
                        Develop a cyclone preparation plan and ensure a copy is
                        available in every unit. Some tips are provided on the<a
                          class="white--text"
                          href="https://www.qld.gov.au/emergency/dealing-disasters/disaster-types/cyclone-severe-storm"
                          >Queensland Government website</a
                        >
                      </li>
                      <li>
                        Trim large trees.
                      </li>
                      Clean out gutters regularly to ensure they are not
                      blocked.
                      <li>
                        Repair any elements that are showing signs of rust or
                        rot.
                      </li>
                    </ul>
                    <p class="pt-3 font-weight-bold">
                      The Queensland Government website has valuable information
                      on preparing your property for tropical cyclones:
                      <a
                        class="white--text"
                        href="https://getready.qld.gov.au/natural-disasters/cyclones/"
                        >Get Ready Queensland</a
                      >
                    </p>
                    <v-flex xs12 class="text-center">
                      <v-btn
                        class=" mt-3 mb-3 white--text "
                        color="white"
                        dark
                        large
                        outlined
                        @click="gotoResilience"
                      >
                        More About Resilience
                      </v-btn>
                    </v-flex>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </section>
        </v-parallax>
      </section>



      <section class="ma-5 pa-5">
        <v-container grid-list-xl>
          <v-layout row wrap justify-center>
            <v-flex md12 lg4>
              <v-card class="elevation-0 transparent mr-2 pl-3 pr-3">
                <v-card-title primary-title class="layout justify-center mb-5">
                  <div class="headline">Areas Covered</div>
                </v-card-title>
                <v-card-text>
                  Inspections are offered <strong>free of cost</strong> for
                  strata properties within 100 km of the coast, north of the
                  southernmost boundary of the Rockhampton Regional council
                  area, extending to the Queensland/Northern Territory border,
                  and including islands off the Queensland coast. Learn more<a
                    @click="gotoAbout"
                    >here.</a
                  >
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex md12 lg4>
              <v-card class="elevation-0 transparent ml-2 pl-3 pr-3">
                <v-card-title primary-title class="layout justify-center mb-5">
                  <div class="headline" id="contact">Contact us</div>
                </v-card-title>
                <v-card-text>
                  For further enquiries contact us at:
                </v-card-text>
                <v-list class="transparent" two-line>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2">mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title
                        >stratatitle@jcu.edu.au</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2">mdi-phone</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>07 4781 5053</v-list-item-title>
                      <v-list-item-title>(+61 7 4781 5053)</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-list class="transparent" three-line subheader>
                  <v-list-item three-line>
                    <v-list-item-action>
                      <v-icon class="blue--text text--lighten-2">mdi-home</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                        College of Science & Engineering
                      </v-list-item-title>
                      <v-list-item-title
                        >James Cook University</v-list-item-title
                      >
                      <v-list-item-title>Townsville</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <section class="ma-5 pa-5">
        <v-container grid-list-xs xs12>


          <v-layout row wrap xs12 justify-center>
            <v-flex md12 lg4>
              <v-card class="elevation-0 transparent mr-2 pl-3 pr-3">
                <v-card-title primary-title class="layout justify-center mb-5">
                  <div class="headline">Related Programs</div>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>


          <v-layout row wrap xs12 justify-center>

            <v-col
                    cols="12"
                    md="4"
            >
              <v-item v-slot="{ active, toggle }">
                <a class="pa-0 ma-0" href="https://weatherthestorm.com.au/" target="_blank">
                  <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center justify-center"
                          dark
                          height="100%"
                  >
                    <v-img
                            :src="require('@/assets/crosslinks/palm-tree-wind.jpg')"
                            aspect-ratio="1.5"
                            class="white--text justify-center align-center "
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                      <v-layout   wrap xs12 justify-center >

                        <v-card-title class="font-weight-black headline ">
                          Weather the Storm
                        </v-card-title>

                      </v-layout>
                    </v-img>
                  </v-card>
                </a>
              </v-item>
            </v-col>
            <v-col
                    cols="12"
                    md="4"
            >
              <v-item v-slot="{ active, toggle }">
                <a class="pa-0 ma-0" href="https://www.jcu.edu.au/swirlnet" target="_blank">
                  <v-card
                          :color="active ? 'primary' : ''"
                          class="d-flex align-center justify-center"
                          dark
                          height="100%"
                          @click="toggle"
                  >
                    <v-img
                            :src="require('@/assets/crosslinks/anemometer-DW-tile.jpg')"
                            aspect-ratio="1.5"
                            class="white--text justify-center align-center "
                            gradient="to bottom, rgba(0,0,0,.2), rgba(0,0,0,.5)"
                    >
                      <v-layout   wrap xs12 justify-center >

                        <v-card-title class="font-weight-black headline">
                          SWIRLnet
                        </v-card-title>


                      </v-layout>
                    </v-img>
                  </v-card>
                </a>
              </v-item>
            </v-col>

          </v-layout>
        </v-container>
      </section>

      <Footer></Footer>
    </v-content>
  </div>
</template>

<style>
.darken-img {
  filter: brightness(50%);
}
.white-background {
  background-color: white !important;
}
.gray-background {
  background-color: #e7e7e7 !important;
}
.v-parallax__image-container:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 770px;
  background-image: linear-gradient(
    to right top,
    #051937,
    #004d7a,
    #008793,
    #00bf72,
    #a8eb12
  );
  opacity: 0.3;
  z-index: 10;
}
[v-cloak] {
  display: none;
}
.admin-msg {
  font-size: 20px;
  font-weight: 500;
}
.hint {
  font-size: 15px;
  font-weight: 500;
}
.subpage-heading-2 {
  margin-bottom: 20px;
}
.white-background {
  background-color: white;
}
.stepper-wrapper {
  height: 250px;
}
.stepper-top {
  height: 100px;
}
.stepper-bottom {
  height: 100px;
}
.stepper-icon {
  width: 100%;
}
.v-card__text{
  color: black !important;
}
a {
  padding-right: 5px;
  padding-left: 5px;
  text-decoration: none;
}

</style>

<script>
import { router } from "../router";
import { Email } from "../smtp/smtp";
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";

export default {
  name: "Home",
  components: {
    Navbar,
    Footer,
    SheetFooter: {
      functional: true,
      render(h, { children }) {
        return h(
          "div",
          {
            staticClass:
              "blue--text font-weight-bold subheading mt-auto align-center justify-center d-flex",
            props: {
              height: 50
            }
          },
          children
        );
      }
    }
  },
  data: () => ({
    items: [
      {
        step: "Step 1",
        text: "Appoint an Authorised Person (AP)",
        icon: "mdi-account",
        color: "blue",
        heading: "Authorised Person (AP)"
      },
      {
        step: "Step 2",
        text: "Register for the SIP Program",
        icon: "mdi-account-edit-outline",
        color: "blue",
        heading: "Registration"
      },
      {
        step: "Step 3",
        text: "Request an Inspection",
        icon: "mdi-account-arrow-right",
        color: "blue",
        heading: "Request"
      },
      {
        step: "Step 4",
        text: "Get your Property Inspected",
        icon: "mdi-calendar-range",
        color: "blue",
        heading: "Inspection"
      },
      {
        step: "Step 5",
        text: "Receive your Report",
        icon: "mdi-file-chart",
        color: "blue",
        heading: "Report"
      },
      {
        step: "Step 6",
        text: "Undertake Selected Recommendations",
        icon: "mdi-clipboard-list-outline",
        color: "blue",
        heading: "Recommendations"
      }
    ]
  }),
  methods: {
    gotoAbout() {
      router.push("/about");
    },
    gotoRegister() {
      router.push("/registration");
    },
    gotoInterest() {
        router.push("/interest");
    },
    gotoDamage() {
      router.push("/damage");
    },
    gotoProcess() {
      router.push("/process");
    },
    gotoResilience() {
      router.push("/resilience");
    }
  }
};
</script>
